{
    "coordinates": [
        25.9500002,
        103.850000
    ],
    "tooltip": "Kuanti",
    "title": "Kuanti Formation",
    "country": "China",
    "period": "Silurian",
    "alt": "TODO"
}
